import axios from 'axios';

import { MainUrl } from "../constants"

const API_URL = `${MainUrl}/template_shift`


export const getTemplateShifts = async (token, restaurantId, startDate, endDate) => {
  let bodyRequest = {
    restaurant_id: restaurantId,
    start_date: startDate,
    end_date: endDate
  }

  const response = await axios.post(`${API_URL}/restaurant_template_shift_with_shifts/`, bodyRequest, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });


  console.log(response.data)
  return response.data
};


export const getTemplateShiftFilter = async (token, date, groupStation, station) => {
  let bodyRequest = {}
  if (date) {
    bodyRequest.date = date
  }
  if (groupStation) {
    bodyRequest.group_station_id = groupStation
  }
  if (station) {
    bodyRequest.station_id = station
  }

  const response = await axios.post(`${API_URL}/filters`, bodyRequest, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
};

export const uploadTemplateShift = async (token, file) => {
  try{
    const formData = new FormData();
    formData.append('file', file)
    const response = await axios.post(`${API_URL}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    })
  return response.data
  }

  catch (error) {
    console.log(error)
  }
}

export const CheckTemplateShift = async (token, file) => {
  try{
    const formData = new FormData();
    formData.append('file', file)
    const response = await axios.post(`${API_URL}/check_dep/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    })
  return response.data
  }

  catch (error) {
    console.log(error)
  }
}


export const getTemplateShift = async (token, id) => {
  const response = await axios.get(`${API_URL}/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
};

export const DeleteTemplateShifts = async (token, restaurantId,  startDate, endDate, ) => {
  try {
    let bodyRequest = {
    restaurant_id: restaurantId,
    start_date: startDate,
    end_date: endDate
  }

  const response = await axios.post(`${API_URL}/delete_by_date/`, bodyRequest, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
  }
  catch (error){
    return error.response.data
  }
  
};


export const FreeTS = async (token, restaurantId,  date, ) => {
  try {
    let bodyRequest = {
    restaurant_id: restaurantId,
    date: date,
  }

  const response = await axios.post(`${API_URL}/free_template_shifts/`, bodyRequest, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
  }
  catch (error){
    return error.response.data
  }
  
};

